import React from 'react';
import ReactDOM from 'react-dom/client';
import './semantic-layer.css';
import './tailwind-output.css';
import './index.css';
import App from '../src/Components/App/App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';

import { PublicClientApplication } from '@azure/msal-browser';
import { ThemeProvider } from './contexts/ThemeContext';

const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
      authority: process.env.REACT_APP_MSAL_AUTHORITY || "https://login.microsoftonline.com/common",
      redirectUri: `${window.location.origin}/auth-end`,
    },
    cache: {
      // sessionStorage, NOT localStorage. With localStorage, msal-browser v4
      // encrypts the cached tokens and parks the AES key in a cookie named
      // "msal.cache.encryption". A cookie written from JS can never carry
      // HttpOnly, so that cookie is permanently flagged by scanners
      // (CWE-1004 / CWE-614). sessionStorage needs no such key, so MSAL
      // writes no cookie at all. Trade-off: the MSAL account cache is
      // per-tab, so a new tab needs one click on "Sign in with Microsoft"
      // (the Entra session cookie makes it prompt-free).
      cacheLocation: "sessionStorage",
      // Auth-state cookies (nonce, state, PKCE verifier) only exist as a fallback
      // for carrying state across a full-page redirect. We use loginPopup, so the
      // originating tab keeps its sessionStorage and the fallback is unnecessary.
      // Disabled so MSAL writes no cookies at all: written from JS they can never
      // carry HttpOnly, and cannot carry Secure while the app is served over HTTP.
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        piiLoggingEnabled: false,
      },
    },
  };
const msalInstance = new PublicClientApplication(msalConfig);
(async () => {
  await msalInstance.initialize();

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root?.render(
    <React.StrictMode>
      <ThemeProvider>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
